
import React from 'react'
import { Dialog } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

interface DeleteFolderModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onDeleteConfirm: () => void
  folderName: string
}

export const DeleteFolderModal: React.FC<DeleteFolderModalProps> = ({
  isOpen,
  onOpenChange,
  onDeleteConfirm,
  folderName,
}) => {
  const handleDelete = () => {
    onDeleteConfirm()
    onOpenChange(false)
  }

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onOpenChange}
      title="Delete Folder"
      description="This action cannot be undone."
      showCloseButton={false}
    >
      <div className="py-4">
        <p>
          Are you sure you want to delete the folder <strong>{folderName}</strong>?
          All contents within this folder will be moved to trash.
        </p>
      </div>
      <div className="mt-4 flex justify-end gap-2">
        <Button variant="ghost" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="destructive" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </Dialog>
  )
}
